import styled, { css, keyframes } from 'styled-components';
import backgroundPin from '@assets/img/background-pin.png';
import backgroundPinOccurrence from '@assets/img/background-pin-occurrence.png';
import { MapContainerPropsInterface } from './MapContainerType';

interface ContainerMapInterface {
  height: number;
  width: MapContainerPropsInterface['width'];
}
export const marginTop = 65;
const markerZindex = 3000;

const PulseOpacity = (color: string) => keyframes`
0% {
  transform: scale(0.97);
  box-shadow: 0 0 0 0 ${color};
}

50% {
  transform: scale(1);
  box-shadow: 0 0 0 20px rgba(0, 0, 0, 0);
}

100% {
  transform: scale(0.97);
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
}
`;

export const ContainerMap = styled.div<ContainerMapInterface>`
  ${({ height, theme, width }) => css`
    width: ${width}px;
    height: calc(${height}px - ${theme.spacing.km6});
    min-width: 300px;
    min-height: 300px;
    z-index: 4;
    margin-top: ${theme.spacing.km6};
    margin-bottom: ${theme.spacing.km6};

    @media screen and (max-width: 1275px) {
      top: 206px;
    }

    .map {
      width: 100%;
      height: 100%;
      border-radius: ${theme.border.radius.default};
    }

    .avatar-icon {
      border-radius: ${theme.border.radius.circle};
    }

    && .leaflet-control-zoom {
      border: none;

      a.leaflet-control-zoom-in,
      a.leaflet-control-zoom-out {
        width: 32px;
        height: 32px;
        border: 1px solid #111;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: ${theme.border.radius.medium};

        + a {
          margin-top: ${theme.spacing.km2};
        }
      }
    }

    .container-icon-avatar {
      transition: width 0.2s, height 0.2s;

      ::before {
        content: '';
        background-image: url(${backgroundPin});
        background-repeat: no-repeat;
        background-size: cover;
        width: 60px;
        height: 62px;
        display: block;
        position: absolute;
        top: -6px;
        left: -50%;
        transition: width 0.2s, height 0.2s;
      }

      .alert-occurence {
        display: none;
        align-items: center;
        justify-content: center;
        width: ${theme.spacing.km5};
        height: ${theme.spacing.km5};
        position: absolute;
        top: -${theme.spacing.km2};
        right: -${theme.spacing.km2};
        border-radius: ${theme.border.radius.circle};
        border: ${theme.border.width.thinner} ${theme.border.style.solid}
          ${theme.color.border.neutral.inverted};
        background-color: ${theme.color.support.orange.weak};

        svg {
          color: ${theme.color.support.orange.strong};
          width: ${theme.spacing.km3};
        }
      }

      &.has--occurence {
        ::before {
          background-image: url(${backgroundPinOccurrence});
        }

        ::after {
          content: '';
          display: block;
          width: ${theme.spacing.km8};
          height: ${theme.spacing.km8};
          border-radius: 50%;
          position: absolute;
          top: 0;
          z-index: -1;
          animation: ${PulseOpacity(theme.color.support.orange.strong)} 2s
            infinite;
        }

        .alert-occurence {
          display: flex;
        }
      }

      &.active-marker,
      &.hover-journey-item-marker,
      :hover {
        z-index: ${markerZindex} !important;
        width: 42px !important;
        height: 42px !important;

        ::before {
          width: 82px;
          height: 84px;
          left: -47%;
          top: -${theme.spacing.km2};
        }

        ::after {
          content: '';
          width: ${theme.spacing.km10};
          height: 42px;
        }

        .wrapper-icon {
          img {
            max-height: 77px !important;
            max-width: 140px !important;
          }
        }
        &.hover-journey-item-marker {
          z-index: ${markerZindex + 1} !important;
        }
      }

      .wrapper-icon {
        position: relative;
        width: 100%;
        height: 100%;
        overflow: hidden;
        border-radius: ${theme.border.radius.circle};
        display: flex;
        align-items: center;
        justify-content: center;
        pointer-events: none;

        img {
          max-height: 60px !important;
          max-width: 100px !important;
        }
      }
    }

    /* Popup */
    .leaflet-popup {
      &-content {
        margin: ${theme.spacing.km0};
        padding: ${theme.spacing.km4};
      }

      &-tip {
        position: relative;
        left: 6px;
      }
    }

    .leaflet-popup-content-wrapper {
      background: none !important;
      border: none !important;
      box-shadow: none !important;
    }

    .leaflet-popup-tip-container {
      display: none !important;
    }

    .leaflet-popup-close-button {
      display: none !important;
    }

    .leaflet-tooltip-top {
      background-color: ${theme.color.background.neutral.inverted} !important;
      border-radius: ${theme.border.radius.medium} !important;
      padding: ${theme.padding.km3} ${theme.padding.km4} !important;
      border: none !important;
      box-shadow: none !important;

      &.leaflet-tooltip-top:before {
        border-top-color: none !important;
      }

      &.leaflet-tooltip {
        background-color: ${theme.color.background.neutral.inverted} !important;
        border: none !important;
        opacity: 1 !important;
      }

      &.leaflet-tooltip .leaflet-tooltip-content {
        color: white !important;
      }
    }
  `}
`;
